import Vue from 'vue'
import { confirmLost, confirmFound } from '../animal-status-update'

export default Vue.component('update-lost-status', {
  props: ['companionAnimalId', 'companionAnimalName', 'token', 'lost', 'imageId', 'listingId' ],
  data() {
    return {
      isLost: this.lost.toString() === '1',
      // Controls whether modal open
      showModal: false,
      // Controls action success/failure messages visibility within modal
      showFailureMessage: false,
      isGuardian: true,
      foundMethod: "",
      comment: "",
      showComment: false
    }
  },
  computed: {
    status() {
      return this.isLost ? 'Report found' : 'Report lost'
    },
    isPlaceholder() {
      return !parseInt(this.imageId)
    },
  },
  methods: {
    showModalType() {
      if (this.isLost) {
        this.showModal = true
      } else {
        window.location = '/lost-pet/lost/add?id=' + this.companionAnimalId
      }
    },
    confirmLost,
    submitFound()  {
      const formData = {
        foundMethod: this.foundMethod,
        comment: this.comment
      }
      confirmFound.apply(this,[this.companionAnimalId, this.token, formData, this.listingId])
    },
    clearModal() {
      this.showModal = false
      this.showFailureMessage = false
      this.foundMethod = ""
      this.comment = ""
    },
    onFoundReasonChange(e) {
      if (e?.target?.value?.toLowerCase() === "other") {
        this.showComment = true
      } else {
        this.showComment = false
      }
    }
  },
})
